/** Puestos con acceso a Nómina colaboradores (menú). No usar texto "JEFE". */
export const PUESTOS_NOMINA_COLABORADORES = [
  11, // JEFE DE TI
  40, // JEFE DE OPERACIONES
  54, // JEFE COMERCIAL
  56, // JEFE DE ADMINISTRACION
  68, // JEFE DE RECURSOS HUMANOS
  107, // JEFE DE CONTROL INTERNO
  48, // COORDINADOR DE INNOVACION ACADEMICA (= JEFE COMERCIAL)
  43, // DIRECTOR GENERAL
]

export function puedeVerMenuNominaColaboradores(usuario) {
  if (!usuario || usuario.idpuesto == null) return false
  return PUESTOS_NOMINA_COLABORADORES.includes(Number(usuario.idpuesto))
}
